export default __webpack_public_path__ + "static/media/placeholderQuestion.82fa84f2.png";